/* eslint-disable no-console */
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { useContext, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CardActions, Grid, Typography } from '@material-ui/core';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import API from '@aws-amplify/api';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import DateFnsUtils from '@date-io/date-fns';
import Divider from '@material-ui/core/Divider';
import capitalize from '../../../utils/capitalize';
import convertDate from '../../../utils/convertDate';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import DeviceContext from '../../context/DeviceContext';
import Feedback from '../../../emilog/components/Feedback';
import AuthContext from '../../../emilog/context/AuthContext';
import LoaderButton from '../../../emilog/components/LoaderButton';
// import DeviceContext from '../../../emilog/context/DeviceContext';

const useStyles = makeStyles((theme) => ({
  card: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%'
  },
  cardContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'stretch', // Make children elements stretch to fill the width
    flexGrow: 1, // Allows cardContent to expand
  },
  datePicker: {
    width: '100%',
    marginTop: '0px',
  },
  cardActions: {
    justifyContent: 'flex-end',
    paddingRight: theme.spacing(2),
  },
  spacer: { // Dient zusammen mit ner Box/Dic als Füllmaterial über z.B. der CardActions Komponente. In tandem mit min-height aus card Klasse.
    flexGrow: 1, // Fills the space above the date picker
  },
}));

interface ServiceAbgeschlossenProps {
  hasServicePlanned: boolean | null
  lastServicePlannedDate: number | null
}

export default function ServiceAbgeschlossen({ hasServicePlanned, lastServicePlannedDate }: ServiceAbgeschlossenProps) {
  const classes = useStyles();

  const { currentDevice, fetchDevices } = useContext(DeviceContext);

  const { currentUser } = useContext(AuthContext);
  const [firstName, lastName] = currentUser?.user.attributes.email.split('@')[0].split('.') ?? ['', ''];
  const author = `${capitalize(firstName)} ${capitalize(lastName)}`;
  const active = currentDevice.serialNumber !== undefined;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [newDate, setNewDate] = useState<MaterialUiPickersDate | null>(null);

  async function handleSubmit() {
    try {
      setLoading(true);
      setError(false);
      setSuccess(false);

      const timestamp = newDate ? Math.round(newDate.getTime() / 1000) : undefined;

      /* Schließt Service ab, indem der Timestamp auf 0 gesetzt wird */
      if (hasServicePlanned) {
        await API.post('emilog', 'updateInfos', {
          body: {
            serialNumber: currentDevice.serialNumber,
            isEmicon: false, // ACHTUNG
            fields: {
              ServiceGeplant: 0, // Aktueller Service
              ServiceGeplant_Alt: lastServicePlannedDate,// Vorheriger Service
              letzterService: timestamp,// Abschluss des vorherigen Service
              /* 
                Reset Anlegen des Service auf 0 bzw. False has Serivice Planned für Mails überprüft in Standaone Lambda checkt ob dieser wert > 0 ist
                Siehe z.B. emicon-notifications in Lambda Repo
               */
              ServiceAngelegt: 0
            },
          },
        });

        await API.post('emilog', 'updateTerminTables', {
          body: {
            tableName: 'EMI-LOG-Servicetermine',
            serialNumber: currentDevice.serialNumber,
            timestamp: timestamp,
            isEmicon: false, // ACHTUNG
          },
        });

        let message = '';

        if (lastServicePlannedDate) {
          message = `Service abgeschlossen (${timestamp !== undefined ? convertDate(timestamp) : 'Kein Gültiges Datum'}). Zieltermin des Service: ${convertDate(lastServicePlannedDate)}`;
        } else {
          message = `Service abgeschlossen (${timestamp !== undefined ? convertDate(timestamp) : 'Kein Gültiges Datum'}). Zieltermin nicht verfügbar`;
        }

        await API.post('emilog', 'addLogbookEntry', {
          body: {
            serialNumber: currentDevice.serialNumber,
            author,
            messageContent: message,
            WartungAbgeschlossen: true, // Eig. Sollte man ServiceAbgeschlossen nehmen, das wäre aber für das Label im Logbuch unnötiger extra Code und umbennen will ic hdas jetz auch nicht 
          },
        });
      }
      fetchDevices();
      setSuccess(true);
      setLoading(false);
    } catch (err) {
      setError(true);
      setLoading(false);
      console.log(err);
    }
  }

  return (
    <Card className={classes.card}>
      <CardHeader
        title="Service abschließen"
      />
      <Divider />

      <CardContent className={classes.cardContent}>

        <Grid container spacing={2}>

          <Grid item xs={12}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                value={newDate}
                label="Durchgeführter Service"
                className={classes.datePicker}
                disableToolbar
                autoOk
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                onChange={(e) => setNewDate(e)}
                invalidDateMessage="Kein korrektes Format"
                inputVariant="outlined"
                disabled={!active}
              />
            </MuiPickersUtilsProvider>
          </Grid>

          {(currentDevice?.ServiceGeplant_Alt && currentDevice?.ServiceGeplant_Alt > 0) && (
            <Grid item xs={12}>
              <Typography>
                Letzter geplanter Service: {convertDate(currentDevice?.ServiceGeplant_Alt)}
              </Typography>
            </Grid>
          )}

          {(hasServicePlanned && hasServicePlanned === true) && (
            <Grid item xs={12}>
              <Typography>
                Aktuell geplanter Service bis zum: {lastServicePlannedDate !== null ? convertDate(lastServicePlannedDate) : ''}
              </Typography>
            </Grid>
          )}

        </Grid>
      </CardContent>
      <Divider />
      <Box className={classes.spacer} /> {/* Spacer div to fill the space above */}
      <CardActions className={classes.cardActions}>
        <Feedback error={error} success={success} />
        <LoaderButton
          isLoading={loading}
          text="Service abschließen"
          onClick={handleSubmit}
          disabled={!active || hasServicePlanned === undefined || hasServicePlanned === null || !newDate || !hasServicePlanned}
        />
      </CardActions>
    </Card>
  );
}
